// DaData (подпроект 11): ключи, расход, учёт запросов.

/** «Настройки → DaData» (`dadata`). */
export const ruDadata = {
  title: 'DaData',
  connection: {
    title: 'Подключение',
    lead: 'Подсказки компаний по ИНН, банков по БИК, адресов, ФИО, почты и паспорта. Ключ хранится в базе зашифрованным и не уходит в браузер',
    on: 'Подключено',
    off: 'Не подключено',
    env: 'Ключ задан на сервере',
    envText:
      'Сейчас работает ключ из настроек сервера. Сохраните свой ключ здесь — он заменит серверный, а расход будет виден ниже',
    none: 'Без ключа поля работают как обычные: ИНН, БИК и счёт проверяются по контрольным суммам, подсказок нет',
    apiKey: 'API-ключ',
    apiKeyHint: '40 знаков из личного кабинета DaData → «API-ключи»',
    secretKey: 'Секретный ключ',
    secretKeyHint: 'Необязательно: нужен для баланса и счётчика DaData',
    secretKeyKeep: 'Оставьте пустым, чтобы не менять сохранённый',
    save: 'Проверить и сохранить',
    saved: 'Ключ DaData сохранён — подсказки работают',
    replace: 'Заменить ключи',
    cancel: 'Отмена',
    disconnect: 'Отключить',
    disconnected: 'DaData отключена',
    keySaved: 'Ключ {mask} · проверен {at}',
    keyUnreadable: 'Ключ сохранён, но не расшифровывается — сохраните его заново',
    withSecret: 'Секретный ключ сохранён',
    withoutSecret: 'Без секретного ключа — баланса DaData не видно',
    openCabinet: 'Открыть личный кабинет DaData',
    hint: {
      title: 'Где взять ключи',
      text: 'Зарегистрируйтесь на dadata.ru и подтвердите почту. В личном кабинете, в разделе «API-ключи», — API-ключ и секретный ключ. Бесплатно — 10 000 запросов подсказок в сутки',
      example: 'API-ключ: 40 латинских букв и цифр, например 3f9c…a1b2',
    },
  },
  usage: {
    title: 'Расход',
    lead: 'Сколько запросов к DaData сделала платформа: сегодня, за 30 дней, каких и откуда. Текст запросов не хранится',
    today: 'Сегодня',
    of: 'из {limit} в сутки',
    states: {
      ok: 'В пределах лимита',
      warning: 'Больше 80% лимита',
      reached: 'Лимит исчерпан',
    },
    reachedText: 'Лимит на сегодня исчерпан: поля работают без подсказок до полуночи по Москве',
    month: 'За 30 дней: {count}',
    failed: 'ошибок: {count}',
    days: 'По дням',
    byKind: 'Что спрашивали',
    byPlace: 'Где спрашивали',
    nothing: 'За 30 дней запросов не было',
    account: 'Личный кабинет DaData',
    balance: 'Баланс',
    suggestionsUsed: 'Подсказок сегодня',
    suggestionsLeft: 'Осталось по тарифу',
    accountHint: {
      title: 'Счётчик DaData',
      text: 'Числа из личного кабинета DaData: они учитывают все запросы с этим ключом, в том числе с других сайтов. Обновляются раз в 5 минут',
      example: 'Подсказок сегодня 1 240 · осталось 8 760',
    },
  },
  limit: {
    label: 'Лимит в сутки',
    hint: {
      title: 'Свой дневной лимит',
      text: 'Платформа не сделает больше запросов за сутки (по Москве). Дошли до лимита — поля работают без подсказок до полуночи. Бесплатный тариф DaData — 10 000 в сутки',
      example: 'Лимит 5 000 оставит половину бесплатных запросов на сайт',
    },
    saved: 'Лимит сохранён',
  },
  calls: {
    title: 'Последние запросы',
    lead: 'Кто, где и что спросил у DaData. Текста запроса здесь нет — там бывают ФИО и паспортные данные',
    empty: 'Запросов пока нет',
    emptyText: 'Как только кто-то воспользуется подсказкой, запрос появится здесь',
    failed: 'Не удалось загрузить запросы',
    more: 'Показать ещё',
    ms: '{value} мс',
    system: 'Платформа',
  },
  kinds: {
    party: 'Компания',
    party_by_id: 'Карточка по ИНН',
    bank: 'Банк',
    address: 'Адрес',
    fio: 'ФИО',
    email: 'Почта',
    fms_unit: 'Кем выдан паспорт',
    iplocate: 'Город по IP',
  },
  places: {
    clients: 'Клиенты',
    contacts: 'Контакты',
    studio: 'Студия',
    employment: 'Данные сотрудника',
    site: 'Заявка с сайта',
    cabinet: 'Кабинет клиента',
    other: 'Другое',
  },
  outcomes: {
    ok: 'Ответ',
    empty: 'Пусто',
    failed: 'Ошибка',
    limit: 'Лимит',
  },
  /** Карточка клиента: статус по ЕГРЮЛ и «Обновить из DaData». */
  company: {
    refresh: 'Обновить из DaData',
    refreshed: 'Реквизиты обновлены из DaData',
    unchanged: 'В DaData то же самое — менять нечего',
    notFound: 'DaData не нашла организацию с этим ИНН',
    statuses: {
      active: 'Действует',
      liquidating: 'Ликвидируется',
      liquidated: 'Ликвидирована',
      bankrupt: 'Банкротство',
      reorganizing: 'Реорганизация',
    },
    statusHint: {
      title: 'Статус по ЕГРЮЛ',
      text: 'DaData проверяет организацию по ИНН раз в сутки. Ликвидированной или банкроту документы лучше не отправлять — уточните реквизиты у клиента',
      example: 'Ликвидирована 12.03.2026',
    },
  },
} as const;

/** «История» и журнал (в `audit`). */
export const ruDadataAudit = {
  actions: {
    requisites: {
      dadata_connected: 'Подключена DaData',
      dadata_keys_changed: 'Заменены ключи DaData',
      dadata_disconnected: 'DaData отключена',
      dadata_limit_changed: 'Изменён дневной лимит DaData',
    },
  },
  entities: {
    requisites_connection: 'Подключение DaData',
  },
  fields: {
    apiKey: 'API-ключ',
    secretKey: 'Секретный ключ',
    dailyLimit: 'Лимит в сутки',
  },
} as const;
